import React from 'react';
import { GigCardType } from '../../types';
import BasicGigCard from '../BasicGigCard/BasicGigCard';
import { VIDEO_STRIP_CARD, VIDEO_STRIP_CARD_CLASS } from '../../../GigCardListings/utils/constants';
import { videoStripCardLayout } from './index.ve.css';

const VideoStripGigCard = (props) => {
    const MAX_GIG_DESCRIPTION_ROWS_NUMBER = 1;

    return (
        <BasicGigCard
            className={videoStripCardLayout}
            layoutClass={VIDEO_STRIP_CARD_CLASS}
            {...props}
            cardType={VIDEO_STRIP_CARD}
            maxRows={MAX_GIG_DESCRIPTION_ROWS_NUMBER}
        />
    );
};

VideoStripGigCard.propTypes = GigCardType;

export default VideoStripGigCard;
